"use strict";

module.exports = require('./ConsoleLog');